import type { PropsWithChildren } from 'react';

import { Card, type IWithPopoverProps, WithPopover } from '@procurify/ui'

import { type Vendor } from '@webapp/models'
import { ConnectedVendorTooltip } from './ConnectedVendorTooltip'

export interface IWithConnectedVendorTooltipProps {
  vendorId: Vendor['id']
  disabled?: boolean
  placement?: IWithPopoverProps['placement']
}

export const WithConnectedVendorTooltip = ({
  vendorId,
  disabled,
  placement = 'top',
  children,
}: PropsWithChildren<IWithConnectedVendorTooltipProps>) => {
  return (
    <WithPopover
      placement={placement}
      isDisabled={disabled}
      maxWidth={600}
      content={
        <Card>
          <Card.Content>
            <ConnectedVendorTooltip vendorId={vendorId} />
          </Card.Content>
        </Card>
      }
    >
      <>{children}</>
    </WithPopover>
  )
}

WithConnectedVendorTooltip.displayName = 'WithConnectedVendorTooltip'
